var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34869",
    "data-name": "Group 34869",
    transform: "translate(-1440 -317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24206",
    "data-name": "Path 24206",
    d: "M10776.853,16662.006h0l-1.65,0a2.2,2.2,0,0,1-2.2-2.2V16642.2a2.2,2.2,0,0,1,2.2-2.2h4.583v5.131a2.017,2.017,0,0,0,2.015,2.016h4.4a2.018,2.018,0,0,0,2.016-2.016V16640h1.656l5.131,5.131v14.674a2.2,2.2,0,0,1-2.2,2.2h-1.651v-6.607a2.018,2.018,0,0,0-2.016-2.016h-10.266a2.018,2.018,0,0,0-2.016,2.016v6.609Zm13.2,0h-12.1v-1h12.1v1Zm0-2h-12.1v-2h12.1v2Zm0-3h-12.1v-1.6a.916.916,0,0,1,.92-.91h10.266a.914.914,0,0,1,.916.91v1.6Zm-3.852-10.947h-4.4a.919.919,0,0,1-.915-.92V16640h6.234v5.131A.922.922,0,0,1,10786.2,16646.051Z",
    transform: "translate(-9323.999 -16314)",
    fill: "#5d93ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6995",
    "data-name": "Rectangle 6995",
    width: 40,
    height: 40,
    transform: "translate(1440 317)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.dd85bf7b8c1edca315e9a4aa33a9e468.svg";
export { ForwardRef as ReactComponent };